import { useTypedSelector } from "../redux/store";

function useLanguage() {
	return useTypedSelector((state) => state.session.language);
}

export default useLanguage;
